// @flow
import * as R from "ramda";
import { Button } from "../common";
import React, { useState } from "react";
// $FlowFixMe
import Select, { type OptionType } from "react-select";

const districtsFile = require("lib/data/districts.json");

interface Props {
	returnValue(string): void;
}

/*
const districts = R.reduce(
	(districts, region) => R.concat(districts, region.comunas),
	[],
	comunas_regiones.regiones
);
*/

const districts = districtsFile.districts;

const Spacing = ({ of }) => <div style={{ height: of }} />;
const DistrictFilter = ({ returnValue, close }: Props) => {
	const [selected, setSelected] = useState<OptionType>({});
	const handleChange = (option: OptionType) => {
		setSelected(option);
	};
	const makeOption = (value) => ({ value, label: value });
	return (
		<div style={{ height: "300px" }}>
			<p>Escoge una comuna</p>
			<Select
				value={selected}
				onChange={handleChange}
				options={districts.map(makeOption)}
			/>
			<Spacing of="17px" />
			<Button
				color="primary"
				size="medium"
				onClick={() => selected.value && returnValue(selected.value)}
			>
				Aplicar
			</Button>
			<Button color="secondary" size="medium" onClick={() => close()}>
				Cerrar
			</Button>
		</div>
	);
};

export default DistrictFilter;
